import {Style,Icon} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import TopoJSON from 'ol/format/TopoJSON';
const gasStationPoiStyle = 
new Style({
  image: new Icon({
    anchor: [0.5, 46],
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    src: 'data/icons/24px/gasstation.png',
    color: '#171A1FFF',
    scale: 0.7
  }),
});

export const poiGasStationLayer = new VectorLayer({
source: new VectorSource({
  url: 'data/india/UP/point_of_interest_ONGTRN.json',
  format: new TopoJSON({
    layers: ['ONGTRN'],
  }),
  overlaps: true,
}),
//minZoom: POI_MIN_ZOOM_LEVEL,
style: gasStationPoiStyle,
visible: true,
zIndex : 2
});
